import { Table } from "types/Table";

export const FRIENDSHIP_CUSTOM_TABLES: Table[] = [
  {
    title: "Silliness salon",
    subtitle: "For the every mind already blown",
    capacity: 6,
    columns: 3,
    rows: 2,
    reference: "Silliness salon",
  },
  {
    title: "New Friends Pods",
    subtitle: "Greet your fellow festival goers",
    capacity: 4,
    columns: 2,
    rows: 2,
    reference: "New Friends Pods",
  },
  {
    title: "The Kids Table",
    subtitle:
      "Have a virgin daiquiri while plotting revenge against your parents",
    capacity: 4,
    columns: 2,
    rows: 2,
    reference: "The Kids Table",
  },
  {
    title: "Philosophy Settees",
    subtitle: "Talk about what it all means",
    capacity: 6,
    columns: 3,
    rows: 2,
    reference: "Philosophy Settees",
  },
  {
    title: "The Loud Lounge",
    subtitle: "A place to drink the night away revelrously",
    capacity: 12,
    columns: 4,
    rows: 3,
    reference: "The Loud Lounge",
  },
  {
    title: "The Solitude Sofa",
    subtitle: "Have a conversation with yourself",
    capacity: 1,
    columns: 1,
    rows: 1,
    reference: "The Solitude Sofa",
  },
  {
    title: "Argumentation Station",
    subtitle: "Indulge in  strong opinions, weakly held",
    capacity: 8,
    columns: 4,
    rows: 2,
    reference: "Argumentation Station",
  },
  {
    title: "Slow date 1",
    subtitle: "Get to know other souls slowly",
    capacity: 2,
    columns: 1,
    rows: 2,
    reference: "Slow date 1",
  },
  {
    title: "Slow date 2",
    subtitle: "Get to know other souls slowly",
    capacity: 2,
    columns: 1,
    rows: 2,
    reference: "Slow date 2",
  },
  {
    title: "Fast date 1",
    subtitle: "Get to know other souls quickly",
    capacity: 2,
    columns: 1,
    rows: 2,
    reference: "Fast date 1",
  },
  {
    title: "Fast date 2",
    subtitle: "Get to know other souls quickly",
    capacity: 2,
    columns: 1,
    rows: 2,
    reference: "Fast date 2",
  },
  {
    title: "Triumphant trios 1",
    subtitle: "Chat in threes",
    capacity: 3,
    columns: 3,
    rows: 1,
    reference: "Triumphant trios 1",
  },
  {
    title: "Triumphant trios 2",
    subtitle: "Chat in threes",
    capacity: 3,
    columns: 3,
    rows: 1,
    reference: "Triumphant trios 2",
  },
  {
    title: "Triumphant trios 3",
    subtitle: "Chat in threes",
    capacity: 3,
    columns: 3,
    rows: 1,
    reference: "Triumphant trios 3",
  },
];
